import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    TextField,
  } from "@mui/material";
  import { useState } from "react";
  
  const DeleteUserDialog = ({
    open,
    onClose,
    onConfirm,
    onDeleteUser,
    confirmOnly = false,
    title,
    content,
  }) => {
    const [confirmText, setConfirmText] = useState("");
    const [password, setPassword] = useState("");
  
    const handleConfirm = async () => {
      if (confirmOnly) {
        onConfirm();
        return;
      }
  
      if (confirmText !== "確認刪除會員資料") {
        alert("請輸入正確的確認文字：確認刪除會員資料");
        return;
      }
  
      if (!password) {
        alert("請輸入密碼");
        return;
      }
  
      try {
        await onDeleteUser(password); // pass password to parent
        onConfirm();
        setConfirmText("");
        setPassword("");
      } catch (err) {
        console.error(err);
      }
    };
  
    const handleClose = () => {
      setConfirmText("");
      setPassword("");
      onClose();
    };
  
    return (
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Typography>{content}</Typography>
          {!confirmOnly && (
            <>
              <TextField
                fullWidth
                margin="normal"
                label="請輸入：確認刪除會員資料"
                value={confirmText}
                onChange={(e) => setConfirmText(e.target.value)}
              />
              <TextField
                fullWidth
                margin="normal"
                label="請輸入密碼"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button color="info" onClick={handleClose}>取消</Button>
          <Button color="error" onClick={handleConfirm}>
            確認
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  
  export default DeleteUserDialog;
  